import { processingSessionItemIdFormat } from "@redotech/redo-ids/ids";
import { SortDispositionSchema } from "@redotech/redo-model/wms/schema/sort-disposition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getProcessingSessionSortDestinations = {
  name: "getProcessingSessionSortDestinations" as const,
  input: z.object({
    returnId: zExt.objectId(),
    // Identifies the operator's station so the per-item destination reflects the
    // bound tote completion will route into. Absent falls back to
    // single-open-session-at-location detection (same as completion).
    workstationId: z.string().optional(),
  }),
  output: z.object({
    sessionDestination: z.string().nullable(),
    itemDestinations: z.record(
      processingSessionItemIdFormat.schema,
      z.string().nullable(),
    ),
    unboundDisposition: SortDispositionSchema.nullable(),
  }),
};
